/*
  fetch polyfill (needed for older versions of Internet Explorer)
*/
import "whatwg-fetch";

import Vue from "vue";
import App from "./App.vue";
// import "./registerServiceWorker";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;
import "./styl/styl.styl";

/*
 >> Global Components >>
*/
import FieldGroup from "@/components/FieldGroup.vue";
import FormField from "@/components/FormField.vue";
Vue.component("field-group", FieldGroup);
Vue.component("form-field", FormField);

import Preloader from "@/components/Preloader.vue";
Vue.component("preloader", Preloader);
// MULTI SELECT
import Multiselect from "vue-multiselect";
Vue.component("multiselect", Multiselect);

// DEVICE DETECTOR
// import device from "vue-device-detector";
// Vue.use(device);

// TOASTER
import Toasted from "vue-toasted";
Vue.use(Toasted, {
  duration: 2000,
  position: "top-center",
  iconPack: "custom-class",
  keepOnHover: true,
  singleton: true,
  theme: "bubble",
  container: "#app"
});

// TOOLTIP
// https://akryum.github.io/v-tooltip/#/
import VTooltip from "v-tooltip";
Vue.use(VTooltip);
// DATE PICKER
import VuePikaday from "@netcz/vue-pikaday";
Vue.use(VuePikaday);
import "@netcz/vue-pikaday/dist/vue-pikaday.min.css";
// TILT
// import VueTilt from "vue-tilt.js";
// Vue.use(VueTilt);
// PAGER
// import VuePaginate from "vue-paginate";
// Vue.use(VuePaginate);

/*
 << Global Components <<
*/
/*
 >> Global Mixins >>
*/

//import './mixins/index.js';
import { validate } from "./mixins/validations.js";
Vue.mixin(validate);
//import { mixinsIndex } from "./mixins/index.js";
//Vue.mixin(mixinsIndex);


/*
 << Global Mixins <<
*/
/*
 >> Global Directives >>
*/

// Vue.directive("uppercase", {
//   update(el) {
//     el.value = el.value.toUpperCase();
//   }
// });
// console.log("VUE> ", new Vue());
// Vue.directive("validate", {
//   update(el) {
//     console.log("validate update >> EL: ", el);
//   },
//   inserted: (el, binding, vnode) => {
//     console.log("EL INSERTED > ", vnode, vnode.context.$store);
//     el.style.backgroundColor = "red";
//   }
// });
/*
 << Global Directives <<
*/

/* EVENT COMMUNCATIONS */
import mitt from "mitt";
Vue.prototype.$eventHub = mitt();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
